import { config, queueApi } from 'services/api';

export async function postQueue(body) {
  return await queueApi.post('queue/', body, config());
}
